var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCvIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23161_5047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.698 27.4605L11.7851 29.5475L23.0198 18.3276V45.2229H25.9802V18.3276L37.2149 29.5475L39.302 27.4605L24.5 12.6584L9.698 27.4605Z",
    fill: "#256EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69795 12.6585V6.73774H39.302V12.6585H42.2624V6.73774C42.2624 5.9526 41.9505 5.19961 41.3953 4.64442C40.8401 4.08924 40.0871 3.77734 39.302 3.77734H9.69795C8.9128 3.77734 8.15981 4.08924 7.60463 4.64442C7.04945 5.19961 6.73755 5.9526 6.73755 6.73774V12.6585H9.69795Z",
    fill: "#256EF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23161_5047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.3664,
    height: 47.3664,
    fill: "white",
    transform: "translate(0.816772 0.816895)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCvIconNew);
export default __webpack_public_path__ + "static/media/upload-cv-icon-new.50f41cc92a8de1d73d16a7aac184a2d5.svg";
export { ForwardRef as ReactComponent };